import { paths } from 'src/routes/paths';

import { setAccessTokenLS, removeAccessTokenLS } from 'src/utils/localStorageUtils';

import axios from 'src/lib/axios';

// ----------------------------------------------------------------------

export function jwtDecode(token: string) {
  try {
    if (!token) return null;

    const parts = token.split('.');
    if (parts.length < 2) {
      throw new Error('Invalid token!');
    }

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = JSON.parse(atob(base64));

    return decoded;
  } catch (error) {
    console.error('Error decoding token:', error);
    throw error;
  }
}

// ----------------------------------------------------------------------

export function isValidToken(accessToken: string) {
  if (!accessToken) {
    return false;
  }

  try {
    const decoded = jwtDecode(accessToken);

    if (!decoded || !('exp' in decoded)) {
      return false;
    }

    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
  } catch (error) {
    console.error('Error during token validation:', error);
    return false;
  }
}

// ----------------------------------------------------------------------

export function tokenExpired(exp: number) {
  const currentTime = Date.now();
  const timeLeft = exp * 1000 - currentTime;

  setTimeout(() => {
    try {
      // sessionStorage.removeItem(JWT_STORAGE_KEY);
      removeAccessTokenLS();
      window.location.href = paths.auth.signIn;
    } catch (error) {
      console.error('Error during token expiration:', error);
      throw error;
    }
  }, timeLeft);
}

// ----------------------------------------------------------------------

export async function setSession(accessToken: string | null) {
  try {
    if (accessToken) {
      // sessionStorage.setItem(JWT_STORAGE_KEY, accessToken);
      setAccessTokenLS(accessToken);

      const decodedToken = jwtDecode(accessToken); // ~3 days by minimals server

      if (decodedToken && 'exp' in decodedToken) {
        tokenExpired(decodedToken.exp);
      } else {
        throw new Error('Invalid access token!');
      }
    } else {
      // sessionStorage.removeItem(JWT_STORAGE_KEY);
      removeAccessTokenLS();
      delete axios.defaults.headers.common.Authorization;
    }
  } catch (error) {
    console.error('Error during set session:', error);
    throw error;
  }
}

// function detectLang(text: string): 'ar' | 'en' {
//   return /[\u0600-\u06FF]/.test(text) ? 'ar' : 'en';
// }

// // Watch for new DOM changes
// const observer = new MutationObserver(() => {
//   document.querySelectorAll('*:not([lang])').forEach((el) => {
//     if (el.childNodes.length === 1 && el.childNodes[0].nodeType === 3) {
//       const text = el.textContent?.trim() || '';
//       if (text) {
//         const lang = detectLang(text);
//         el.setAttribute('lang', lang);
//       }
//     }
//   });
// });

// observer.observe(document.body, { childList: true, subtree: true });
